import { request } from '../utils/request'
import { stringify } from '../utils/index'

export default {
  getverificationcorps: option => request('v1/verificationcorp/getverificationcorps', option), // 核验机构列表
  deleteverificationcorp: (option) => request('v1/verificationcorp/deleteverificationcorp' + stringify(option), option), // 删除核验机构
  addverificationcorp: (option) => request('v1/verificationcorp/addverificationcorp', option), // 新增核验机构
  updateverificationcorp: (option) => request('v1/verificationcorp/updateverificationcorp', option), // 修改核验机构

  getverificationusers: option => request('v1/verificationuser/getverificationusers', option), // 核验机构员工列表
  deleteverificationuser: (option) => request('v1/verificationuser/deleteverificationuser' + stringify(option), option), // 删除核验机构员工
  addverificationuser: (option) => request('v1/verificationuser/addverificationuser', option), // 新增核验机构员工
  updateverificationuser: (option) => request('v1/verificationuser/updateverificationuser', option), // 修改核验机构员工

  getexamquestions: option => request('v1/examquestion/getexamquestions', option), // 查询题目列表
  addexamquestion: (option) => request('v1/examquestion/addexamquestion', option), // 新增题目
  updateexamquestion: (option) => request('v1/examquestion/updateexamquestion', option), // 修改题目
  deleteexamquestion: (option) => request('v1/examquestion/deleteexamquestion' + stringify(option), option), // 删除题目

  getverificationorders: option => request('v1/verificationorder/getverificationorders', option) // 核验记录
}
